import React, { useState } from 'react'
import { useTranslate, useNotify, useStore } from 'react-admin'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { Delete, Add, Edit } from '@mui/icons-material'
import { ModalEditApp } from './ModalEditApp'
import Button from '@mui/material/Button'
import { userServices } from 'src/services/auth/user/user.service'
import { Skeleton } from '@mui/material'

export const TableAppByClient = ({ list, setList, hashuser }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [idUserByClientApp, setIdUserByClientApp] = useState()
  const [idApplication, setIdApplication] = useState()
  const [idCliente, setIdCliente] = useState()
  const [dashboard, setDashboard] = useState()
  const [config, setConfig] = useState()
  const [_, setHashUser] = useStore('hash_user_edit')

  const handleOpen = (id, application_id, cliente_id, dashboard, config) => {
    setHashUser(hashuser)
    setIdUserByClientApp(id)
    setIdApplication(application_id)
    setIdCliente(cliente_id)
    setOpen(true)
    setDashboard(dashboard)
    setConfig(config)
  }

  const handleButton = async (id, is_active) => {
    try {
      setLoading(true)
      const response = await userServices.putUserByClientApp({ is_active: !is_active }, id)
      if (!response) {
        notify(translate('ra.notification.error_updated'), { type: 'error' })
        setLoading(false)
      }

      const newList = list?.map((item) => {
        if (item.id === id) {
          return { ...item, is_active: !is_active }
        }
        return item
      })
      setList(newList)
      setLoading(false)
    } catch (error) {
      notify(translate('ra.notification.error_updated'), { type: 'error' })
      setLoading(false)
    }
  }

  const handleClose = () => setOpen(false)
  return (
    <>
      {loading ? (
        <Skeleton variant='rectangular' width={'100%'} height={400} />
      ) : (
        <TableContainer component={Paper} sx={{ marginY: '30px' }}>
          <Table sx={{ minWidth: 650 }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell>{translate('ra.field.client')}</TableCell>
                <TableCell align='left'>{translate('ra.field.application')}</TableCell>
                <TableCell align='left'>{translate('ra.field.dashboard')}</TableCell>
                <TableCell align='left'>{translate('ra.field.is_active')}</TableCell>
                <TableCell align='left'>{translate('ra.field.action')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {React.Children.toArray(
                list?.map((row) => {
                  const { client, application, application_id, id, client_id, is_active, dashboard, config } =
                    row
                  return (
                    <>
                      <TableRow
                        key={`${application_id}__${client_id}`}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          backgroundColor: is_active ? 'white' : '#f9f9f9',
                        }}
                      >
                        <TableCell component='th' scope='row'>
                          {client.long_name}
                        </TableCell>
                        <TableCell align='left'>{application.long_name}</TableCell>
                        <TableCell align='left'>{dashboard}</TableCell>
                        <TableCell align='left'>{is_active ? 'Si' : 'No'}</TableCell>
                        <TableCell align='left'>
                          <div>
                            <Button
                              onClick={(e) => handleOpen(id, application_id, client_id, dashboard, config)}
                              disabled={!is_active}
                              startIcon={<Edit />}
                            />
                            <Button
                              size='small'
                              startIcon={is_active ? <Delete /> : <Add />}
                              color={is_active ? 'error' : 'success'}
                              onClick={(e) => handleButton(id, is_active)}
                            >
                              {is_active ? translate('ra.action.disable') : translate('ra.action.enable')}
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  )
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <ModalEditApp
        handleClose={handleClose}
        open={open}
        userByClient_id={idUserByClientApp}
        application_id={idApplication}
        client_id={idCliente}
        dashboard={dashboard}
        config={config}
      />
    </>
  )
}
